<twc-dialog-skeleton>
  <ng-container dialog-title i18n>Import shipment</ng-container>
  <ng-container dialog-content>
    <twc-alert-card [type]="AlertType.NOTICE" class="display-block mb-16">
      <span class="twc-typography-body-1 twc-color-primary-typeface">
        Shipment is created using AI. Review details after creation.
      </span>
    </twc-alert-card>
    <form
      id="importShipmentForm"
      class="pb-24"
      [formGroup]="form"
      (ngSubmit)="importShipment()"
    >
      <div class="form-field full-width mt-12">
        <span class="mb-7 twc-typography-body-1 twc-color-primary-typeface"
          >Attachment</span
        >
        <twc-multi-file-uploader
          formControlName="documents"
          [allowedFileTypes]="acceptedFormats"
          [maxFileSize]="maxFileSize"
        ></twc-multi-file-uploader>
      </div>
    </form>
  </ng-container>
  <ng-container dialog-actions>
    <button mat-stroked-button mat-dialog-close i18n>Cancel</button>
    <button
      form="importShipmentForm"
      class="twc-color-white"
      [loading]="busy()"
      [disabled]="!form.valid"
      color="primary"
      type="submit"
      mat-flat-button
      i18n
    >
      Import
    </button>
  </ng-container>
</twc-dialog-skeleton>
